import { useMemo, useState } from 'react';

import { arrayMove } from '@dnd-kit/sortable';

export default function useAttachments({ seedAttachments }) {
  const initialCurrentAttachments = useMemo(
    () =>
      seedAttachments.data.map((a) => ({
        id: a.id,
        hashid: a.attributes.hashid,
        position: a.attributes.position,
        displaySizeValue: a.attributes.displaySizeValue,
        caption: a.attributes.caption,
        recordType: a.attributes.recordType,
      })),
    [JSON.stringify(seedAttachments)],
  );

  const [currentAttachments, setCurrentAttachments] = useState(
    initialCurrentAttachments,
  );

  const handleAttachmentDelete = ({ hashid }) => {
    setCurrentAttachments((prev) => prev.filter((a) => a.hashid !== hashid));
  };

  const handleAttachmentInsert = ({ index, props }) => {
    setCurrentAttachments((prev) => [
      ...prev.slice(0, index),
      props,
      ...prev.slice(index),
    ]);
  };

  const handleAttachmentUpdate = ({ hashid, props }) => {
    setCurrentAttachments((prev) =>
      prev.map((a) => (a.hashid === hashid ? { ...a, ...props } : a)),
    );
  };

  const handleAttachmentsReorder = ({ active, over }) => {
    setCurrentAttachments((prev) => {
      const startIndex = currentAttachments.findIndex(
        (a) => a.hashid === active.id,
      );
      const finishIndex = currentAttachments.findIndex(
        (a) => a.hashid === over.id,
      );

      return arrayMove(prev, startIndex, finishIndex).map((a, index) => ({
        ...a,
        position: index + 1,
      }));
    });
  };

  const handleTmpAttachmentCreate = ({ tmpId }) => {
    setCurrentAttachments((prev) => {
      const maxPosition = Math.max(0, ...prev.map((a) => a.position));
      return [
        ...prev,
        { hashid: tmpId, position: maxPosition + 1, displaySizeValue: 1 },
      ];
    });
  };

  return {
    currentAttachments,
    handleAttachmentDelete,
    handleAttachmentInsert,
    handleAttachmentUpdate,
    handleAttachmentsReorder,
    handleTmpAttachmentCreate,
    initialCurrentAttachments,
  };
}
